import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { UserAccountState } from './state';

const getters: GetterTree<UserAccountState, RootState> = {
  studentEmailProviders: (state, getters) => {
    return state.studentEmailProvider;
  },
  studentEmailHasAccounts: (state, getters) => {
    return state.studentEmailHasAccounts;
  },
  emailTokenD: (state, getters) => {
    return state.emailTokenD;
  },
};

export default getters;
